/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EncuestaCancelacionDto } from '../../models/encuesta-cancelacion-dto';

export interface AnaliticasControllerObtenerFormularioCancelacion$Params {
}

export function analiticasControllerObtenerFormularioCancelacion(http: HttpClient, rootUrl: string, params?: AnaliticasControllerObtenerFormularioCancelacion$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EncuestaCancelacionDto>>> {
  const rb = new RequestBuilder(rootUrl, analiticasControllerObtenerFormularioCancelacion.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<EncuestaCancelacionDto>>;
    })
  );
}

analiticasControllerObtenerFormularioCancelacion.PATH = '/api/paciente-analiticas/formulario-cancelacion';
